// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_jszip_dist_jszip_min_js":"605890dfbe55b646","node_modules_pptxviewjs_dist_PptxViewJS_es_js":"052be618fbfc7fa7","node_modules_hammerjs_hammer_js":"60b44c084c68b095"}[chunkId] + ".js";
};